/**
 * Created by Administrador on 15/10/2025.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {

        $stateProvider
            .state('reprintBackup', {
                parent: 'app',
                url: '/reprintBackup?code&page&size',
                params: {
                    page: "0",
                    size: "10",
                    code: "",
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/reprintBackup/reprintBackup.html',
                        controller: 'reprintBackupCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['reprint']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabReprint('reprintBackup')
                            }]
                        }
                    }
                }
            })
    }
})();
